
export const CreateGroupType = {
  pointMatch: 3, // 积分赛
  knockoutMatch: 4, // 淘汰赛
  cupMatch: 5, // 杯赛
  quickMatch: 6, // 快速赛
  customMatch: 7, // 自定义
  repeatedMatch: 8, // 匹配循环赛
  douleRepeatedMatch: 2, // 双败淘汰赛
  swissWheel: 9, // 瑞士轮
  win: 10, // 匹配获胜赛
};
